import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Switch from "react-switch";

class DuplicateChecklist extends React.Component {
  state = {
    locations: this.props.locations
  };

  toggleLocations = selected => {
    var locations = this.state.locations;

    var locationFormElements = this.state.locations.map((location, index) => {
      location.included = selected;
      locations[index] = location;
    });

    this.setState({ locations: locations });
  };

  toggleLocation = (e, location, index) => {
    var locations = this.state.locations;
    location.included = !location.included;
    locations[index] = location;
    this.setState({ locations: locations });
  };

  renderLocations() {
    var that = this;

    var locationFormElements = this.state.locations.map((location, index) => {
      return (
        <div key={index} className="row">
          <div className="col-xs-1">
            <br />
            <Switch
              checked={location.included ? true : false}
              onChange={e => that.toggleLocation(e, location, index)}
              onColor="#DADCE1"
              onHandleColor="#3A4590"
              handleDiameter={25}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={20}
              width={48}
              className="react-switch"
              id="material-switch"
            />
          </div>
          <div className="col-xs-11">
            <br />
            <p>{location.name}</p>
          </div>
        </div>
      );
    });

    return <div>{locationFormElements}</div>;
  }

  duplicateChecklist() {
    var that = this;
    var locationIds = _.map(
      _.filter(this.state.locations, { included: true }),
      "id"
    );
    var checklist = this.props.checklist;

    axios
      .get("/schedule_duplicate_checklist", {
        params: {
          checklist_id: checklist.id,
          location_ids: locationIds
        }
      })
      .then(function(response) {
        toastr.success(
          "Checklist has been duplicated, please check your email for confirmation"
        );
        setTimeout(
          function() {
            Turbolinks.visit("/admin_dashboard/");
          }.bind(this),
          1000
        );
      })
      .catch(function(error) {
        toastr.error("Checklist not duplicated");
        console.log(error);
      });
  }

  renderSaveButton() {
    var that = this;

    return (
      <button
        type="button"
        className="btn btn-pink full-width"
        onClick={function() {
          that.duplicateChecklist();
        }}
      >
        SAVE
      </button>
    );
  }

  render() {
    var that = this;

    return (
      <div>
        <h1 className="h1-stacked">Duplicate Checklist</h1>
        <center>
          <h2 className="date-h2">{this.props.checklist.name}</h2>
        </center>
        <br />
        <div className="shadowDepth1 well">
          <h4>Locations</h4>
          <button
            type="button"
            className="btn btn-text margin-right-five"
            onClick={function() {
              that.toggleLocations(true);
            }}
          >
            Select All
          </button>
          <button
            type="button"
            className="btn btn-text"
            onClick={function() {
              that.toggleLocations(false);
            }}
          >
            Deselect All
          </button>
          {that.renderLocations()}
          <hr />
          {that.renderSaveButton()}
        </div>
      </div>
    );
  }
}

DuplicateChecklist.propTypes = {
  checklist: PropTypes.object,
  currentUser: PropTypes.object,
  locations: PropTypes.array
};

export default DuplicateChecklist;
